import { ComboChart } from '../../charts/ComboChart';
import { ChartModelHelper } from '../../helpers/ChartModelHelper';
import type { IComponentFacts } from '../../types/report';
import { EmptyFacts } from '../EmptyFacts';
import { CURRENCY_AXIS_WIDTH, moneyFormatter } from './chartFormatters';
import { useChartStyle } from './useChartStyle';
import { useTrendMonths } from './useTrendMonths';

interface IBurnRunwayChartProps {
  facts: IComponentFacts;
}

const LABELS = {
  netBurn: 'Net burn',
  cash: 'Cash + inv',
  runway: 'Runway (mo)',
};

export const BurnRunwayChart = ({ facts }: IBurnRunwayChartProps) => {
  const months = useTrendMonths(facts, { allowPreliminary: true });
  const style = useChartStyle(3);
  const rows = ChartModelHelper.burnRunway(facts.table, months);
  if (!ChartModelHelper.hasSeries(rows, 'netBurn')) return <EmptyFacts />;
  return (
    <ComboChart
      {...style}
      className="h-full"
      data={ChartModelHelper.relabel(rows, LABELS)}
      index="label"
      enableBiaxial
      barSeries={{
        categories: [LABELS.netBurn, LABELS.cash],
        colors: ['rose', 'blue'],
        valueFormatter: moneyFormatter(facts.currency),
        yAxisWidth: CURRENCY_AXIS_WIDTH,
      }}
      lineSeries={{
        categories: [LABELS.runway],
        colors: ['emerald'],
        valueFormatter: (v) => `${v.toFixed(0)} mo`,
        yAxisWidth: 44,
        connectNulls: true,
      }}
    />
  );
};
